import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import useCss from "../../../../../../hooks/useCss";
import styles from "../styles";
import SbuxTranslate from "../../../../../../components/SbuxTranslate";

interface LexSectionProps {
  title: string;
  annotation?: string;
  children: ReactNode;
}

const LexSection = ({ title, annotation, children }: LexSectionProps) => {
  const classes = useCss(styles);
  return (
    <Box className={classes.section}>
      <Typography className={classes.sectionLabel}>
        <SbuxTranslate>{title}</SbuxTranslate>
        {annotation && (
          <Typography component="span" className={classes.sectionAnnotation}>
            <SbuxTranslate>{annotation}</SbuxTranslate>
          </Typography>
        )}
      </Typography>
      {children}
    </Box>
  );
};

export default LexSection;
